"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var menu_1 = require("../../utils/shopify/menu");
var Overlay_1 = require("../common/Overlay");
var MenuSlider_1 = require("./MenuSlider");
var NavMenu = function (_a) {
    var open = _a.open, handleSlide = _a.handleSlide;
    var _b = (0, hooks_1.useState)(null), menus = _b[0], setMenus = _b[1];
    // On the first render, grab all menus via GraphQL &
    // add event lister to window to toggle the nav from outside of preact
    (0, hooks_1.useEffect)(function () {
        (0, menu_1.getMenus)()
            .then(function (data) { return setMenus(data); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!menus) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)("div", { class: "nav-menu" },
        (0, preact_1.h)(MenuSlider_1.default, { open: open, handleSlide: handleSlide, menus: menus }),
        (0, preact_1.h)(Overlay_1.default, { open: open, closeFn: function () { return handleSlide(null); } })));
};
exports.default = NavMenu;
